import * as Yup from "yup";

export const schemaFamilyDetails = Yup.object().shape({
  childEmail: Yup.string().email("Field email is wrong"),
  childFirstName: Yup.string().when("childEmail", {
    is: (email: string) => email && email.length > 0,
    then: Yup.string().required(
      "First name is required when email is provided"
    ),
  }),
  childSecondName: Yup.string().when("childEmail", {
    is: (email: string) => email && email.length > 0,
    then: Yup.string().required("Last name is required when email is provided"),
  }),

  firstEmailAdoptiveFamily: Yup.string().email("Field email is wrong"),
  firstFirstNameAdoptiveFamily: Yup.string().when("firstEmailAdoptiveFamily", {
    is: (email: string) => email && email.length > 0,
    then: Yup.string().required(
      "First name is required when email is provided"
    ),
  }),
  firstLastNameAdoptiveFamily: Yup.string().when("firstEmailAdoptiveFamily", {
    is: (email: string) => email && email.length > 0,
    then: Yup.string().required("Last name is required when email is provided"),
  }),

  secondEmailAdoptiveFamily: Yup.string().email("Field email is wrong"),
  secondFirstNameAdoptiveFamily: Yup.string().when(
    "secondEmailAdoptiveFamily",
    {
      is: (email: string) => email && email.length > 0,
      then: Yup.string().required(
        "First name is required when email is provided"
      ),
    }
  ),
  secondLastNameAdoptiveFamily: Yup.string().when("secondEmailAdoptiveFamily", {
    is: (email: string) => email && email.length > 0,
    then: Yup.string().required("Last name is required when email is provided"),
  }),

  firstEmailBiologicFamily: Yup.string().email("Field email is wrong"),
  firstFirstNameBiologicFamily: Yup.string().when("firstEmailBiologicFamily", {
    is: (email: string) => email && email.length > 0,
    then: Yup.string().required(
      "First name is required when email is provided"
    ),
  }),
  firstLastNameBiologicFamily: Yup.string().when("firstEmailBiologicFamily", {
    is: (email: string) => email && email.length > 0,
    then: Yup.string().required("Last name is required when email is provided"),
  }),

  secondEmailBiologicFamily: Yup.string().email("Field email is wrong"),
  secondFirstNameBiologicFamily: Yup.string().when(
    "secondEmailBiologicFamily",
    {
      is: (email: string) => email && email.length > 0,
      then: Yup.string().required(
        "First name is required when email is provided"
      ),
    }
  ),
  secondLastNameBiologicFamily: Yup.string().when("secondEmailBiologicFamily", {
    is: (email: string) => email && email.length > 0,
    then: Yup.string().required("Last name is required when email is provided"),
  }),
});
